import { GetEventBadgeResponse } from './src/service-plugins-types.js';
import { GetEventBadgeEnvelope } from './src/interfaces-events-badges-v1-event-badges-spi.public.js';

export * from './src/service-plugins-types';
export { GetEventBadgeEnvelope };

/**
 * Returns a badge to display on a specific event.
 *
 * Wix calls this method synchronously when the storefront or dashboard reads
 * events with the `BADGES` fieldset requested. For each event in the read
 * pipeline, Wix fans out to every applicable installed implementer in parallel.
 *
 * Wix uses the returned `badge` to surface contextual information on the event
 * card. If multiple badges apply, downstream UI ranks them by `badgeType`
 * priority and most recent implementer edit time. Aggregated badge results are
 * cached per site and event.
 *
 * **Error handling:** If your implementation returns an error or times out, Wix
 * logs the failure and omits your badge for that request. Other implementers'
 * badges can still appear, and no retries are performed at the service plugin layer.
 */
export declare function getEventBadge(
  payload: GetEventBadgeEnvelope
): GetEventBadgeResponse | Promise<GetEventBadgeResponse>;
